module.exports = __webpack_public_path__ + "static/media/logo-word-long.9d83c4d2.svg";